<template>
  <div class="login-wrap">
    <div class="phone-inner" v-if="wayType === 'phone'">
      <notice-txt
        :txt="`${$t($loginLangPrefix('userSign.reged'), {
          name: `(+${itc}) ${phoneCode}`,
        })}`"
      />
      <!-- <notice-txt
        :txt="`(+${itc}) ${phoneCode} ${$t(
          $loginLangPrefix('userSign.reged')
        )}`"
      /> -->
      <password-input
        hide="true"
        log="log"
        @changePassword="changePasswordHandle"
        @changePasswordError="changePasswordErrorHandle"
        @btnSure="keyVal"
      />
      <error-tip :txt="passwordError" />
      <code-input
        ref="codeInputRef"
        v-if="codeState"
        :name="name"
        type="phone"
        @changeCode="changeCodeHandle"
        @changeCodeError="changeCodeErrorHandle"
        @btnSure="keyVal"
      />
      <error-tip v-if="codeState" :txt="codeError" />
      <button-wrap
        :has="actBtn"
        :cover="cover"
        :txt="$t($loginLangPrefix('userSign.signIn'))"
        @btnSure="keyVal"
      />
      <p class="have" @click="showForget()">
        {{ $t($loginLangPrefix("userSign.forget")) }}
      </p>
    </div>
    <div class="mphone-inner" v-if="wayType === 'm-phone'">
      <title-txt :txt="$t($loginLangPrefix('userSign.signIn'))" />
      <notice-txt
        mb="mb"
        :txt="`${$t($loginLangPrefix('userSign.reged'), {
          name: `(+${itc}) ${phoneCode}`,
        })}`"
      />
      <password-input
        hide="true"
        log="log"
        mb="mb"
        @changePassword="changePasswordHandle"
        @changePasswordError="changePasswordErrorHandle"
      />
      <error-tip :txt="passwordError" mb="mb" />
      <code-input
        ref="codeInputRef"
        v-if="codeState"
        :name="name"
        type="phone"
        mb="mb"
        @changeCode="changeCodeHandle"
        @changeCodeError="changeCodeErrorHandle"
      />
      <error-tip v-if="codeState" :txt="codeError" mb="mb" />
      <button-wrap
        mb="mb"
        :has="actBtn"
        :cover="cover"
        :txt="$t($loginLangPrefix('userSign.signIn'))"
        @btnSure="keyVal"
      />
      <p class="have mb" @click="showForget()">
        {{ $t($loginLangPrefix("userSign.forget")) }}
      </p>
    </div>
  </div>
</template>
<script>
import util from '@utils/util';
import error from '../common/error';
import logreg from '../js/logreg';
import notice from '../common/notice';
import title from '../common/title';
import codeInput from '../common/code';
import button from '../common/button';
import passwordInput from '../common/password';
import api from '../js/api';

export default {
  name: 'loginwrap',
  props: {
    name: { type: String, default: '' },
    itc: { type: String, default: '' },
    wayType: { type: String, default: '' }
  },
  data() {
    return {
      password: '',
      code: '',
      codeError: '',
      passwordError: '',
      phoneCode: '',
      cover: false,
      codeState: false,
      mPublicKey: ''
    };
  },
  computed: {
    actBtn() {
      return (
        ((!!this.code && !this.codeError) || !this.codeState)
        && !!this.password
        && !this.passwordError
      );
    }
  },
  components: {
    'error-tip': error,
    'notice-txt': notice,
    'title-txt': title,
    'code-input': codeInput,
    'password-input': passwordInput,
    'button-wrap': button
  },
  methods: {
    changePasswordHandle(password) {
      this.password = password;
    },
    changePasswordErrorHandle(txt) {
      this.passwordError = txt;
    },
    changeCodeErrorHandle(txt) {
      this.codeError = txt;
    },
    changeCodeHandle(code) {
      this.code = code;
    },
    showForget() {
      this.$emit('showForget', this.wayType, this.name, this.itc);
    },
    logIn() {
      if (
        this.password
        && ((this.code && !this.codeError) || !this.codeState)
        && !this.passwordError
        && !this.cover
      ) {
        this.cover = true;
        const loading = util.loadingFunc();
        logreg.channelSignin(
          this.name,
          this.password,
          this.code,
          this.mPublicKey,
          logreg.REGTYPE.phone,
          0,
          (state, data) => {
            this.cover = false;
            try {
              loading.hide();
            } catch (e) {
              console.log(e);
            }
            if (state === 'success') {
              this.$emit('success', data);
            } else if (state === 'need_captcha') {
              // this.passwordError = this.$t(this.$loginLangPrefix('userSign.webLoginPasswordErrorTips'));
              if (data.ret && data.ret === '40001') {
                this.codeError = this.$t(
                  this.$loginLangPrefix('userSign.codeError')
                );
              } else {
                this.passwordError = this.$t(
                  this.$loginLangPrefix('userSign.webLoginPasswordErrorTips')
                );
              }
              this.codeState = true;
            } else if (
              (window.errorMessageLoginTip
                && window.errorMessageLoginTip.indexOf(`${data.status}`) >= 0)
              || (window.errorMessageLoginTip
                && window.errorMessageLoginTip.indexOf(
                  data.data && `${data.data.status}`
                ) >= 0)
            ) {
              // this.passwordError = this.$t(this.$loginLangPrefix('userSign.fkError'));
            } else if (data.data && data.data.status === '601') {
              this.codeError = this.$t(
                this.$loginLangPrefix('userSign.codeError')
              );
            } else if (data.errorMessageTMXTip) {
              //
            } else {
              this.passwordError = this.$t(
                this.$loginLangPrefix('userSign.webLoginPasswordErrorTips')
              );
            }
            if (this.codeState) {
              this.$refs.codeInputRef && this.$refs.codeInputRef.getVerify();
            }
          }
        );
      }
    },
    keyVal() {
      api.rsaKey().then((data) => {
        this.mPublicKey = data.pubkey;
        this.logIn();
      }).catch((response) => {
        console.log(response);
      });
    }
  },

  beforeMount() {},

  mounted() {},

  watch: {
    name(val) {
      if (val) {
        const reg = new RegExp(this.itc, 'i');
        this.phoneCode = val.replace(reg, '');
      }
    }
  },

  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
@function rem($n) {
  @return ($n * 1rem / 50);
}
.login-wrap {
  position: relative;
  width: 100%;
  .have {
    margin-top: 10px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: "RobotoRegular";
    font-weight: normal;
    color: rgba(153, 153, 153, 1);
    line-height: 14px;
    text-decoration: underline;
    cursor: pointer;
    &.mb {
      margin-top: rem(10);
      line-height: rem(14);
    }
  }
}
</style>
